
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match-booster/faqs",
      function () {
        return require("private-next-pages/match-booster/faqs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match-booster/faqs"])
      });
    }
  